// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1xxN3","active":"Header_active__3bJ3W","right-side":"Header_right-side__3Xrqu"};